export const ReturnUrl = 'returnUrl';

export const QueryParameterNames = {
  ReturnUrl: ReturnUrl,
  Message: 'message',
};

export const LogoutActions = {
  LogoutCallback: 'LogoutCallback',
  Logout: 'Logout',
  LoggedOut: 'LoggedOut',
  Forbidden: 'Forbidden',
};

export const LoginActions = {
  Login: 'Login',
  LoginCallback: 'LoginCallback',
  LoginFailed: 'LoginFailed',
  Profile: 'Profile',
  Register: 'Register',
};

const applicationPaths = {
  DefaultLoginRedirectPath: '/',
  ApiAuthorizationClientConfigurationUrl: `/_configuration/`,
  Login: `Authentication/${LoginActions.Login}`,
  LoginFailed: `Authentication/${LoginActions.LoginFailed}`,
  LoginCallback: `Authentication/${LoginActions.LoginCallback}`,
  Register: `Authentication/${LoginActions.Register}`,
  Profile: `Authentication/${LoginActions.Profile}`,
  LogOut: `Authentication/${LogoutActions.Logout}`,
  LoggedOut: `Authentication/${LogoutActions.LoggedOut}`,
  LogOutCallback: `Authentication/${LogoutActions.LogoutCallback}`,
  Forbidden: `Authentication/${LogoutActions.Forbidden}`,
  LoginPathComponents: [],
  LoginFailedPathComponents: [],
  LoginCallbackPathComponents: [],
  RegisterPathComponents: [],
  ProfilePathComponents: [],
  LogOutPathComponents: [],
  LoggedOutPathComponents: [],
  LogOutCallbackPathComponents: [],
  IdentityRegisterPath: '/Identity/Account/Register',
  IdentityManagePath: '/Identity/Account/Manage',
};

export const ApplicationPaths = {
  ...applicationPaths,
  LoginPathComponents: applicationPaths.Login.split('/'),
  LoginFailedPathComponents: applicationPaths.LoginFailed.split('/'),
  RegisterPathComponents: applicationPaths.Register.split('/'),
  ProfilePathComponents: applicationPaths.Profile.split('/'),
  LogOutPathComponents: applicationPaths.LogOut.split('/'),
  LoggedOutPathComponents: applicationPaths.LoggedOut.split('/'),
  LogOutCallbackPathComponents: applicationPaths.LogOutCallback.split('/'),
};
